const initialState = {
  graph2: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'GRAPH2':
      const { graph2 } = action;
      return {
        ...state,
        graph2,
      };
    default:
      return state;
  }
};

export const setGraph2 = (
  graph2,
) => ({
  type: 'GRAPH2',
  graph2,
});
